module.exports = __webpack_public_path__ + "img/下单ico.d31f7e3d.png";